import {useMemo} from 'react';
import {useLocation} from 'react-router-dom';

export const REF_CODE_KEY = 'refCode';

const useReferralCode = () => {
  const location = useLocation();
  const referralCode = useMemo(() => {
    const url = new URLSearchParams(location.search);
    return url.get(REF_CODE_KEY);
  }, [location]);
  return {
    referralCode,
  };
};

export default useReferralCode;
